import { InputEntity } from "../../..";
import { TransmedRegistrationStage } from "../registration/registration";

export class TransmedRegistrationValidateInput extends InputEntity {
  public constructor(
    public stage: TransmedRegistrationStage,
    public rejection_message: string | null
  ) {
    super();
  }
}
